import React from "react";
import Banner from "../../Components/AfterSchoolProgram/Banner/Banner";
import Blurb from "../../Components/AfterSchoolProgram/Blurb/Blurb";
import PhotoContainer from "../../Components/AfterSchoolProgram/PhotoContainer/PhotoContainer";
import ChooseVariety from "../../Components/AfterSchoolProgram/ChooseVariety/ChooseVariety";
import Footer from "../../Components/AfterSchoolProgram/Footer/Footer";
import "./style.css";
import SEO from "../../Components/SEO";

export default function AfterSchoolProgram() {
  return (
    <div className="afterSchool-container">
      <SEO
        title="BWC Sports | After School Programs"
        description=""
        url="https://bwcsports.com/after-school-programs"
      />
      <Banner />
      <Blurb />
      <PhotoContainer />
      <ChooseVariety />
      <Footer />
    </div>
  );
}
